import Button from '../Button/Button';
// import Action from '../../shared/Action/Action';
import './loadMore.scss';

interface ILoadMoreProps {
    count: number;
    itemsListLength: number;
    onClick: (count: number) => void;
    itemsLimit: number;
}

const LoadMore: React.FC<ILoadMoreProps> = ({ count, itemsListLength, onClick, itemsLimit }) => {
    const clickHandler = () => {
        if (count >= itemsListLength) return;

        count += itemsLimit;
        onClick(count);
    };

    return (
        <Button extraClass="loadMoreBtn" onClick={clickHandler} mode={'primary'}>
            Показать ещё
        </Button>
        // <Action extraClass="loadMoreBtn" onClick={clickHandler} as="button">
        //     Показать ещё
        // </Action>
    );
};

export default LoadMore;
